<template>
  <b-modal
    id="update"
    hide-footer
    @shown="getScheduleById"
    no-close-on-backdrop
    size="lg"
    modal-class="modern-modal"
  >
    <template v-slot:modal-title>
      <div class="modal-title-modern">
        <i class="fas fa-calendar mr-2"></i>
        Detalhes do Agendamento
      </div>
    </template>

    <div class="modal-content-modern">
      <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
        <form @submit.prevent="update" class="schedule-form">
          <!-- Informações Básicas Card -->
          <div class="form-card">
            <div class="card-header">
              <h4 class="card-title">
                <i class="fas fa-info-circle mr-2"></i>
                Informações Básicas
              </h4>
            </div>
            <div class="card-content">
              <div class="form-grid">
                <!-- Tipo de Agendamento -->
                <div class="form-group">
                  <LabelRequiredField label="Tipo de Agendamento" />
                  <v-select
                    v-model="schedule.schedule_type_id"
                    :items="schedules_types"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    hide-details
                    class="modern-select"
                    placeholder="Selecione o tipo"
                    clearable
                  />
                </div>

                <!-- Residente -->
                <div class="form-group">
                  <LabelRequiredField label="Residente" />
                  <v-select
                    v-model="schedule.resident_id"
                    :items="residents"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    hide-details
                    class="modern-select"
                    placeholder="Selecione o residente"
                    clearable
                  />
                </div>

                <!-- Data do Agendamento -->
                <div class="form-group">
                  <LabelRequiredField label="Data do Agendamento" />
                  <input
                    type="date"
                    v-model="schedule.date"
                    class="modern-input"
                    placeholder="Selecione a data"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Horário Card -->
          <div class="form-card">
            <div class="card-header">
              <h4 class="card-title">
                <i class="fas fa-clock mr-2"></i>
                Configuração de Horário
              </h4>
            </div>
            <div class="card-content">
              <!-- Opção de Horário -->
              <div class="form-group">
                <label class="form-label"
                  >Informar horário do agendamento?</label
                >
                <div class="radio-group">
                  <div class="radio-option">
                    <input
                      type="radio"
                      id="horarioSim"
                      :value="true"
                      v-model="hasTime"
                      class="radio-input"
                    />
                    <label for="horarioSim" class="radio-label">
                      <span class="radio-custom"></span>
                      <span class="radio-text">Sim</span>
                    </label>
                  </div>

                  <div class="radio-option">
                    <input
                      type="radio"
                      id="horarioNao"
                      :value="false"
                      v-model="hasTime"
                      @change="cleanTime"
                      class="radio-input"
                    />
                    <label for="horarioNao" class="radio-label">
                      <span class="radio-custom"></span>
                      <span class="radio-text">Não</span>
                    </label>
                  </div>
                </div>
              </div>

              <!-- Horários (quando ativado) -->
              <div v-if="hasTime" class="time-section">
                <div class="time-grid">
                  <div class="form-group">
                    <label class="form-label">
                      <i class="fas fa-play mr-1"></i>
                      Horário Inicial
                    </label>
                    <input
                      type="time"
                      v-model="schedule.time_init"
                      class="modern-input"
                    />
                  </div>

                  <div class="form-group">
                    <label class="form-label">
                      <i class="fas fa-stop mr-1"></i>
                      Horário Final
                    </label>
                    <input
                      type="time"
                      v-model="schedule.time_end"
                      class="modern-input"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Observações Card -->
          <div class="form-card">
            <div class="card-header">
              <h4 class="card-title">
                <i class="fas fa-sticky-note mr-2"></i>
                Observações
              </h4>
            </div>
            <div class="card-content">
              <div class="form-group">
                <label class="form-label">Observação</label>
                <textarea
                  v-model="schedule.note"
                  class="modern-textarea"
                  placeholder="Digite observações sobre o agendamento..."
                  rows="4"
                />
              </div>
            </div>
          </div>

          <!-- Erros -->
          <ErrorsMessages :errors="errors" />

          <!-- Ações -->
          <div class="form-actions">
            <div class="actions-grid">
              <confirmation-dialog
                v-if="schedule.id"
                message-title="EXCLUIR AGENDAMENTO"
                message-body="Tem certeza que deseja excluir este agendamento? Esta ação não pode ser desfeita."
                open-class="btn-modern btn-modern-delete"
                open-left-icon="fa-trash"
                open-text="Excluir"
                @yes="deleteSchedule(schedule.id)"
              />

              <v-btn :disabled="loading" type="submit" class="btn-save-modern">
                <i class="fas fa-save mr-2"></i>
                {{ loading ? "Salvando..." : "Salvar Agendamento" }}
              </v-btn>
            </div>
          </div>
        </form>
      </b-overlay>
    </div>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import LabelRequiredField from "../Components/LabelRequiredField";
import api from "../../services/api";
import toast from "../../lib/ToastNotification";
import ConfirmationDialog from "../Components/ConfirmationDialog.vue";

export default {
  name: "UpdateModal",

  components: {
    LabelRequiredField,
    ErrorsMessages,
    ConfirmationDialog,
  },

  data() {
    return {
      errors: [],
      schedule: [],
      hasTime: false,
      loading: false,
    };
  },

  props: {
    schedule_id: {
      type: Number,
      default: null,
    },

    schedules_types: {
      type: Array,
      default: () => [],
    },

    residents: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    async getScheduleById() {
      try {
        this.loading = true;

        let params = { id: this.schedule_id };

        const response = await api.get("/schedule", { params });

        const { error, schedule } = response.data;

        if (!error) {
          this.schedule = schedule;
          this.hasTime = schedule.time_init ? true : false;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error(error);
      }
    },

    async update() {
      try {
        this.loading = true;

        const id = this.schedule.id;
        const schedule_type_id = this.schedule.schedule_type_id;
        const resident_id = this.schedule.resident_id;
        const date = this.schedule.date;
        const time_init = this.schedule.time_init;
        const time_end = this.schedule.time_end;
        const note = this.schedule.note;

        let params = {
          id,
          schedule_type_id,
          resident_id,
          date,
          time_init,
          time_end,
          note,
        };

        const response = await api.put("/schedule", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("update");
          toast(message, "success");
          this.errors = [];
          this.$emit("update", "schedule_type");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    async deleteSchedule() {
      try {
        this.loading = true;

        const id = this.schedule.id;

        let params = { id };

        const response = await api.delete("/schedule", { params });

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("update");
          toast(message, "success");
          this.errors = [];
          this.$emit("update", "schedule_type");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    cleanTime() {
      this.schedule.time_init = "";
      this.schedule.time_end = "";
      this.errors = [];
    },
  },
};
</script>

<style scoped>
/* Modal Styling */
.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.modal-title-modern i {
  color: #0f65b0;
}

.modal-content-modern {
  padding: 8px 0;
}

.loading-overlay {
  border-radius: 12px;
  min-height: 400px;
}

/* Form Layout */
.schedule-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Form Cards */
.form-card {
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.card-header {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.card-title i {
  color: #0f65b0;
}

.card-content {
  padding: 20px;
  background: white;
}

/* Form Grid */
.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.time-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

/* Form Groups */
.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 0;
  display: flex;
  align-items: center;
}

.form-label i {
  color: #6b7280;
  font-size: 12px;
}

/* Modern Inputs */
.modern-input,
.modern-textarea {
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
}

.modern-input:focus,
.modern-textarea:focus {
  border-color: #0f65b0;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1);
  outline: none;
}

.modern-textarea {
  resize: vertical;
  min-height: 100px;
}

/* Radio Group */
.radio-group {
  display: flex;
  gap: 24px;
  margin-top: 8px;
}

.radio-option {
  display: flex;
  align-items: center;
}

.radio-input {
  display: none;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  transition: all 0.3s ease;
}

.radio-custom {
  width: 20px;
  height: 20px;
  border: 2px solid #d1d5db;
  border-radius: 50%;
  position: relative;
  transition: all 0.3s ease;
  background: white;
}

.radio-custom::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #0f65b0;
  transition: transform 0.3s ease;
}

.radio-input:checked + .radio-label .radio-custom {
  border-color: #0f65b0;
}

.radio-input:checked + .radio-label .radio-custom::after {
  transform: translate(-50%, -50%) scale(1);
}

.radio-label:hover .radio-custom {
  border-color: #0f65b0;
  background: #f0f9ff;
}

/* Time Section */
.time-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}

/* Form Actions */
.form-actions {
  border-top: 1px solid #e5e7eb;
  padding-top: 24px;
  margin-top: 8px;
}

.actions-grid {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

/* Buttons */
.btn-save-modern {
  background: linear-gradient(135deg, #1e884d 0%, #16a34a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 32px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(30, 136, 77, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-save-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(30, 136, 77, 0.4) !important;
}

.btn-save-modern:disabled {
  opacity: 0.7 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

/* Delete Button (se necessário customizar via CSS) */
.btn-delete-modern {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-delete-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4) !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .modal-content-modern {
    padding: 0;
  }

  .form-grid,
  .time-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .card-header {
    padding: 12px 16px;
  }

  .card-content {
    padding: 16px;
  }

  .radio-group {
    flex-direction: column;
    gap: 16px;
  }

  .actions-grid {
    flex-direction: column-reverse;
    gap: 12px;
  }

  .btn-save-modern,
  .btn-delete-modern {
    width: 100% !important;
    justify-content: center !important;
  }
}

@media (max-width: 480px) {
  .card-title {
    font-size: 14px;
  }

  .form-label {
    font-size: 13px;
  }

  .modern-input,
  .modern-textarea {
    padding: 10px 12px;
    font-size: 13px;
  }

  .btn-save-modern,
  .btn-delete-modern {
    padding: 10px 20px !important;
    font-size: 14px !important;
  }
}

/* Override Vuetify Styles */
.modern-select >>> .v-input__control {
  border-radius: 8px !important;
}

.modern-select >>> .v-select__slot {
  padding: 12px 16px !important;
}

.modern-select >>> .v-input__slot {
  border: 2px solid #e5e7eb !important;
  background: white !important;
}

.modern-select >>> .v-input--is-focused .v-input__slot {
  border-color: #0f65b0 !important;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1) !important;
}

.modern-select >>> .v-select__selection {
  font-weight: 500 !important;
  color: #374151 !important;
}

/* Modal Override */
.modern-modal >>> .modal-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
  border-bottom: 1px solid #e5e7eb !important;
  border-radius: 0 !important;
}

.modern-modal >>> .modal-body {
  padding: 24px !important;
}

.modern-modal >>> .modal-content {
  border-radius: 16px !important;
  border: none !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
}
</style>